import invert from 'lodash/invert'
import type {
  createStylesParams,
  createSettingsParams,
  StyleParamType,
  SettingsParamType,
} from '@wix/tpa-settings'

export type StylesParamsType<T extends Record<string, StyleParamType>> = ReturnType<
  typeof createStylesParams<T>
>
export type SettingsParamsType<T extends Record<string, SettingsParamType>> = ReturnType<
  typeof createSettingsParams<T>
>

export enum BreadcrumbsAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum TextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum ButtonAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Stretch = 'Stretch',
}

export enum FormLayout {
  Packed = 'packed',
  Strip = 'strip',
}

// Tools for converting settingsParams to styleParams

export enum Alignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Stretch = 'stretch',
}

export const AlignmentStringToNumber: Record<Alignment, number> = {
  [Alignment.Left]: 0,
  [Alignment.Center]: 1,
  [Alignment.Right]: 2,
  [Alignment.Stretch]: 3,
}

export const AlignmentNumberToString = invert(AlignmentStringToNumber)

export const convertAlignmentNumberToString = (alignment: number) =>
  AlignmentNumberToString[alignment] as Alignment

export const convertAlignmentStringToNumber = (alignment: Alignment): number =>
  AlignmentStringToNumber[alignment]

export enum ImageSize {
  Crop = 'crop',
  Fit = 'fit',
}

export const ImageSizeStringToNumber: Record<ImageSize, number> = {
  [ImageSize.Crop]: 0,
  [ImageSize.Fit]: 1,
}

export const ImageSizeNumberToString = invert(ImageSizeStringToNumber)

export const convertImageSizeNumberToString = (alignment: number) =>
  ImageSizeNumberToString[alignment] as ImageSize

export const convertImageSizeStringToNumber = (alignment: ImageSize): number =>
  ImageSizeStringToNumber[alignment]
